package br.com.texeratx.boardgametimeapp

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import br.com.texeratx.boardgametimeapp.ui.navigation.AppNavigation
import br.com.texeratx.boardgametimeapp.ui.theme.AppTheme
import org.koin.compose.getKoin
import br.com.texeratx.boardgametimeapp.core.theme.ThemeManager

@Composable
fun MainApp() {
    val themeManager = getKoin().get<ThemeManager>()
    val themeMode = themeManager.theme.collectAsState().value

    LaunchedEffect(Unit) { themeManager.init() }

    AppTheme(themeMode = themeMode) {
        AppNavigation()
    }
}
